/** Menú principal (Home grid) y herramientas (quick-actions). Fuente única para Home + dropdown. */

export type MainMenuItem = {
  to: string;
  icon: string;
  labelKey: string;
  prefetch?:
    | 'battlepass'
    | 'calendar'
    | 'spin'
    | 'specialoffert'
    | 'auction'
    | 'titlemanager'
    | 'ranking'
    | 'uniques'
    | 'schedule'
    | 'register'
    | 'droplogs'
    | 'chatbot';
};

export type ToolMenuItem = {
  to: string;
  labelKey: string;
  /** Clase Phosphor Icons (ya cargada en el appweb) */
  phIcon: string;
  external?: boolean;
};

export const MAIN_MENU_ITEMS: readonly MainMenuItem[] = [
  { to: '/battlepass', icon: 'battlepass.webp', labelKey: 'battle_pass', prefetch: 'battlepass' },
  { to: '/calendar', icon: 'daily.webp', labelKey: 'daily_login', prefetch: 'calendar' },
  { to: '/spin', icon: 'wheel.webp', labelKey: 'spin_title', prefetch: 'spin' },
  { to: '/specialoffert', icon: 'special_offert.webp', labelKey: 'special_offer', prefetch: 'specialoffert' },
  { to: '/auctionsystem', icon: 'auction.webp', labelKey: 'auction_system', prefetch: 'auction' },
  { to: '/titlemanager', icon: 'title.webp', labelKey: 'title_manager', prefetch: 'titlemanager' },
  { to: '/ranking', icon: 'ranking.webp', labelKey: 'ranking', prefetch: 'ranking' },
  { to: '/uniqueshistory', icon: 'unique.webp', labelKey: 'unique', prefetch: 'uniques' },
  { to: '/schedule', icon: 'schedule.webp', labelKey: 'schedule', prefetch: 'schedule' },
  { to: '/register', icon: 'register.webp', labelKey: 'register', prefetch: 'register' },
  { to: '/chatbot', icon: 'ia.webp', labelKey: 'r_ia', prefetch: 'chatbot' },
  { to: '/logsystem', icon: 'drop.webp', labelKey: 'drop_log', prefetch: 'droplogs' },
] as const;

export const TOOL_MENU_ITEMS: readonly ToolMenuItem[] = [
  { to: '/guide', labelKey: 'guide', phIcon: 'ph-light ph-book-open', external: true },
  { to: '/jobsystem', labelKey: 'job_system', phIcon: 'ph-light ph-briefcase' },
  { to: '/vipsystem', labelKey: 'vip_system', phIcon: 'ph-light ph-crown' },
  { to: '/cupons', labelKey: 'cupon_title', phIcon: 'ph-light ph-ticket' },
  { to: '/setting', labelKey: 'settings', phIcon: 'ph-light ph-gear' },
  { to: '/messages', labelKey: 'messages', phIcon: 'ph-light ph-envelope' },
  { to: '/notifications', labelKey: 'notifications_title', phIcon: 'ph-light ph-bell' },
  { to: '/donation', labelKey: 'donation', phIcon: 'ph-light ph-heart' },
  { to: '/dailytasks', labelKey: 'dt_title', phIcon: 'ph-light ph-check-square' },
  { to: '/surveys', labelKey: 'surveys', phIcon: 'ph-light ph-clipboard-text' },
] as const;
